import { ComponentClass } from 'react';
export { ComponentClass };

import { createLazyComponent, LazyModule } from 'owa-bundling';
import { ContactPickerPaneProps } from './components/ContactPickerPane';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "ContactPickerPane", webpackPrefetch: true */ './lazyIndex')
);

// Delayed Loaded Components
export var ContactPickerPane = createLazyComponent(lazyModule, m => m.ContactPickerPane);
export { ContactPickerPaneProps };
